<template>
  <div class="max-w-[327px] sm:max-w-[909px] w-full sm:min-h-screen">
    <div class="flex flex-row justify-between items-center sm:sticky top-[130px] mb-6 sm:z-2 sm:bg-[#F7F8FB] sm:pt-6">
      <div class="text-20 leading-6 font-semibold text-black py-4">{{ date.format('MMMM YYYY') }}</div>
      <div class="flex items-center mr-[3px]">
        <OButton
          v-if="Math.abs(date.diff(dayjs(), 'month')) > 2"
          pure
          class="border-2 rounded-lg mr-2 py-1 px-3 font-semibold text-lg"
          @click="today"
        >
          Bugün
        </OButton>
        <OButton
          pure
          class="border-2 cursor-pointer rounded-lg mr-2 u-center"
          :disabled="loading || isFirstDay"
          :class="{ 'opacity-30 cursor-default': isFirstDay }"
          style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
          @click="changeMonth(-1)"
        >
          <OIcon icon="chevron-left" />
        </OButton>
        <OButton
          pure
          class="border-2 cursor-pointer rounded-lg u-center"
          :disabled="isCurrentMonth"
          :class="{ 'opacity-30 cursor-default': isCurrentMonth }"
          style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
          @click="changeMonth(+1)"
        >
          <OIcon icon="chevron-right" />
        </OButton>
      </div>
    </div>
    <div class="flex flex-row flex-wrap justify-between sm:justify-start gap-y-6 sm:gap-y-10 sm:gap-x-8">
      <div v-for="game in games" :key="game.id">
        <BilpopCard v-if="currentTab === 'bilpop'" :game="game" />
        <EmojileCard v-else :game="game" />
      </div>
    </div>
    <div v-if="isMobile" class="flex items-center mt-4 justify-end">
      <OButton
        v-if="Math.abs(date.diff(dayjs(), 'month')) > 2"
        pure
        class="border-2 rounded-lg mr-2 py-1 px-3 font-semibold text-lg"
        @click="today"
      >
        Bugün
      </OButton>
      <OButton
        pure
        class="border-2 cursor-pointer rounded-lg mr-2 u-center"
        :disabled="loading || isFirstDay"
        :class="{ 'opacity-30 cursor-default': isFirstDay }"
        style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
        @click="changeMonth(-1)"
      >
        <OIcon icon="chevron-left" />
      </OButton>
      <OButton
        pure
        class="border-2 cursor-pointer rounded-lg u-center"
        :disabled="isCurrentMonth"
        :class="{ 'opacity-30 cursor-default': isCurrentMonth }"
        style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
        @click="changeMonth(+1)"
      >
        <OIcon icon="chevron-right" />
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, useAsync, useContext, ssrRef, computed } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import { throttle } from 'lodash';
import BilpopCard from './BilpopCard.vue';
import EmojileCard from './EmojileCard.vue';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
export default defineComponent({
  setup(props) {
    const { $service } = useContext();
    const { isLoggedIn, user } = useAuth();
    const games = ssrRef('');
    const loading = ref('');
    const { isMobile } = useDevice();
    dayjs.locale('tr');

    const date = ref(dayjs(new Date(props.year, props.month, 1)));

    const changeMonth = throttle(async (count) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      date.value = date.value.add(count, 'month');
      await getMonthlyGames();
    }, 500);

    const today = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        date.value = dayjs();
        getMonthlyGames();
      }, 500);
    };

    const getMonthlyGames = async () => {
      try {
        loading.value = true;
        const userParams = isLoggedIn.value ? { withStatuses: true, playerId: user.value._id } : {};
        const { data } = await $service.game.listGamesMonthly({
          gameType: props.currentTab,
          year: date.value.year(),
          month: date.value.month(),
          ...userParams,
        });
        games.value = data;
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
      }
    };

    const isFirstDay = computed(() => {
      if (props.currentTab === 'emojile') {
        // emojile -> Mayıs 2022
        const filterMonth = date.value.month();
        const filterYear = date.value.year();
        return filterYear === 2022 && filterMonth === 4;
      } else if (props.currentTab === 'bilpop') {
        // bilpop ilk oyun -> Ağustos 2023
        const filterMonth = date.value.month();
        const filterYear = date.value.year();
        return filterYear === 2023 && filterMonth === 7;
      }
      return false;
    });

    const isCurrentMonth = computed(() => {
      const filterMonth = date.value.month();
      const currentMonth = dayjs().month();
      const filterYear = date.value.year();
      const currentYear = dayjs().year();
      return filterYear === currentYear && filterMonth === currentMonth;
    });

    useAsync(async () => {
      await getMonthlyGames();
    });
    return { games, isMobile, changeMonth, today, date, dayjs, isFirstDay, isCurrentMonth, loading };
  },
  components: {
    BilpopCard,
    OButton,
    EmojileCard,
    OIcon,
  },
  props: {
    currentTab: {
      required: true,
      type: String,
    },
    year: {
      required: false,
      default: dayjs().year(),
    },
    month: {
      required: false,
      default: dayjs().month(),
    },
  },
});
</script>
